import { observer } from 'mobx-react-lite'
import { useEffect, useRef, useState } from 'react'

import { useCallContext } from '@src/app/voice/ongoing-call/context/useCallContext'
import IconButton from '@src/component/IconButton'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { CallRecordActiveIcon, CallRecordDefaultIcon } from '@ui/icons/tint/20/general'
import { theme } from '@ui/theme'

const RecordingActiveIcon = observer(() => {
  const recordingIntervalId = useRef<number | null>(null)
  const [recordingCircleBgColor, setRecordingCircleBgColor] = useState(
    `rgb(${theme.palette.secondary.red.default})`,
  )

  useEffect(() => {
    if (!recordingIntervalId.current) {
      recordingIntervalId.current = window.setInterval(() => {
        setRecordingCircleBgColor((value) =>
          value === 'transparent'
            ? `rgb(${theme.palette.secondary.red.default})`
            : 'transparent',
        )
      }, 1000)
    } else if (recordingIntervalId.current) {
      clearInterval(recordingIntervalId.current)
      recordingIntervalId.current = null
      setRecordingCircleBgColor(`rgb(${theme.palette.secondary.red.default})`)
    }

    return () => {
      if (recordingIntervalId.current) {
        clearInterval(recordingIntervalId.current)
      }
    }
  }, [])

  return <CallRecordActiveIcon color={recordingCircleBgColor} />
})

const RecordingButton = observer(({ className }: { className?: string }) => {
  const { call } = useCallContext()

  return (
    // eslint-disable-next-line custom-rules/no-deprecated-buttons, @typescript-eslint/no-deprecated -- FIXME: https://linear.app/openphone/issue/UXP-4347/migrate-deprecated-buttons-to-ds-button
    <IconButton
      icon={
        call.recordingStatus === 'in-progress' ? (
          <RecordingActiveIcon />
        ) : call.recordingStatus === null ? (
          <LoadingIndicator size={14} variant="circular" color="gray" />
        ) : (
          <CallRecordDefaultIcon />
        )
      }
      title={
        call.recordingStatus === 'in-progress'
          ? 'Stop call recording'
          : call.recordingStatus === null
          ? ''
          : 'Record call'
      }
      color={undefined}
      backgroundColor={`rgb(${theme.palette.overlay.default})`}
      hoverColor={call.isRecording ? undefined : 'red'}
      size={34}
      className={className}
      tooltip={{
        themeKey: 'dark',
        colorScheme: 'call',
        placement: 'top',
      }}
      disabled={call.recordingStatus === null}
      onClick={() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- UXP-3744 - Fix Promise-related ESLint issues
        call.toggleRecord()
      }}
    />
  )
})

export default RecordingButton
